import script from "./CurrentWeek.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentWeek.vue?vue&type=script&setup=true&lang=js"

import "./CurrentWeek.vue?vue&type=style&index=0&id=497fd17c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497fd17c"]])

export default __exports__